import {useState} from "react";
import {updateComponent} from "../../services/Administrative/componentService";

export const useUpdateComponent = () => {

    const [updatingComponent, setUpdatingComponent] = useState(false);

    const updateExistingComponent = async (componentDTO: {}, id: number) => {
        setUpdatingComponent(true);
        try {
            return await updateComponent(componentDTO, id);
        } catch (error:any) {
            throw error
        }
        finally {
            setTimeout(() => {setUpdatingComponent(false);}, 600)
        }
    };

    return { updateExistingComponent, updatingComponent };
};
